import { PictureOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import { PropsWithChildren } from 'react';
import { Tab, tabTypeMap } from '../../model/types';
import OrganizationTab from './OrganizationTab';
import PluginTab from './PluginTab';
import TicketTab from './TicketTab';
import UserTab from './UserTab';

const styles = {
    emptyImage: { height: 20, fontSize: 20 },
    emptyContainer: { fontSize: 10 }
};

interface Props {
    tab: Tab;
}

export default function TabView({ children, tab = {} as Tab }: PropsWithChildren<Props>) {
    if (children) return <>{children}</>;
    const { type } = tab;

    switch (type) {
        case tabTypeMap.DEAL:
            return <Empty image={<PictureOutlined />} imageStyle={styles.emptyImage} style={styles.emptyContainer} />;
        case tabTypeMap.ORGANIZATION:
            return <OrganizationTab tab={tab} />;
        case tabTypeMap.PLUGIN:
            return <PluginTab tab={tab} />;
        case tabTypeMap.TICKET:
            return <TicketTab tab={tab} />;
        case tabTypeMap.USER:
            return <UserTab tab={tab} />;
        default:
            return <Empty image={<PictureOutlined />} imageStyle={styles.emptyImage} style={styles.emptyContainer} />;
    }
}
